/* SHOEBAAZAR · Shop by Size — only in-stock sizes. Designed & developed by BLYNTL */
(function(){
  var CACHE_MS = 5 * 60 * 1000;
  var loads = {};
  function store(key, val){ try{ sessionStorage.setItem(key, JSON.stringify({t:Date.now(), d:val})); }catch(e){} }
  function recall(key){ try{ var o = JSON.parse(sessionStorage.getItem(key)); if(o && Date.now()-o.t < CACHE_MS) return o.d; }catch(e){} return null; }

  function slim(p){
    var idx = -1;
    (p.options||[]).forEach(function(o,i){ if(/size/i.test(o.name)) idx = i; });
    if(idx < 0) return null;
    var key = 'option' + (idx+1);
    var vars = [];
    p.variants.forEach(function(v){
      var n = parseFloat(String(v[key]||'').replace(/[^0-9.]/g,''));
      if(!isNaN(n)) vars.push({id:v.id, s:n, label:String(v[key]).replace(/^\s*eu\s*/i,''), a:!!v.available, p:parseFloat(v.price), c:v.compare_at_price?parseFloat(v.compare_at_price):0});
    });
    var imgs = (p.images||[]).slice(0,2).map(function(i){ return i.src; });
    return {h:p.handle, t:p.title, d:p.published_at||p.created_at, i:imgs, v:vars};
  }

  function fetchAll(scope){
    if(loads[scope]) return loads[scope];
    var ck = 'sbsize:' + scope;
    var hit = recall(ck);
    if(hit) return (loads[scope] = Promise.resolve(hit));
    var base = scope === 'all' ? '/products.json' : '/collections/' + encodeURIComponent(scope) + '/products.json';
    var out = [];
    function page(n){
      return fetch(base + '?limit=250&page=' + n, {credentials:'same-origin'})
        .then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); })
        .then(function(j){
          (j.products||[]).forEach(function(p){ var s = slim(p); if(s) out.push(s); });
          if((j.products||[]).length === 250 && n < 20) return page(n+1);
          return out;
        });
    }
    loads[scope] = page(1).then(function(r){ store(ck, r); return r; });
    return loads[scope];
  }

  function money(amount, fmt){
    var v = Number(amount).toFixed(2).split('.');
    var whole = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amt = whole + '.' + v[1];
    return (fmt||'Rs.{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      if(k === 'amount_no_decimals') return whole;
      if(k === 'amount_with_comma_separator') return whole.replace(/,/g,'.') + ',' + v[1];
      return amt;
    });
  }
  function sized(src, w){ if(!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function esc(s){ return String(s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function matches(prod, size){ return prod.v.filter(function(v){ return v.a && Math.floor(v.s) === size; }); }

  function card(prod, hits, fmt){
    var low = hits.reduce(function(m,v){ return v.p < m.p ? v : m; }, hits[0]);
    var sale = low.c > low.p;
    var pct = sale ? Math.round((low.c - low.p) / low.c * 100) : 0;
    var labels = hits.map(function(v){ return v.label; }).filter(function(x,i,a){ return a.indexOf(x) === i; });
    var img = prod.i[0], alt = prod.i[1];
    return '<a class="sb-card" href="/products/' + prod.h + '?variant=' + low.id + '">' +
      '<div class="sb-card__media">' +
        (sale ? '<span class="sb-badge sb-badge--sale">-' + pct + '%</span>' : '') +
        (img ? '<img loading="lazy" src="' + sized(img,540) + '" srcset="' + sized(img,360) + ' 360w,' + sized(img,540) + ' 540w,' + sized(img,720) + ' 720w" sizes="(min-width:1200px) 25vw,(min-width:750px) 33vw,50vw" alt="' + esc(prod.t) + '">' : '') +
        (alt ? '<img class="sb-card__alt" loading="lazy" src="' + sized(alt,540) + '" alt="">' : '') +
        '<span class="sb-card__quick">View pair</span>' +
      '</div>' +
      '<div class="sb-card__body">' +
        '<h3 class="sb-card__title">' + esc(prod.t) + '</h3>' +
        '<div class="sb-card__price"><span' + (sale ? ' class="is-sale"' : '') + '>' + money(low.p, fmt) + '</span>' + (sale ? '<s>' + money(low.c, fmt) + '</s>' : '') + '</div>' +
        '<span class="sb-card__fit">EU ' + esc(labels.join(' / ')) + ' in stock</span>' +
      '</div></a>';
  }

  function init(root){
    var scope = root.getAttribute('data-scope') || 'all';
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 12;
    var fmt = root.getAttribute('data-money');
    var chips = [].slice.call(root.querySelectorAll('.sb-chip'));
    var grid = root.querySelector('[data-grid]');
    var bar = root.querySelector('.sb-size__bar');
    var status = root.querySelector('.sb-size__status');
    var sortSel = root.querySelector('[data-sort]');
    var moreBtn = root.querySelector('[data-more]');
    var empty = root.querySelector('[data-empty]');
    var state = {size:null, list:[], shown:0, data:null};

    function skeleton(){
      var h = '';
      for(var i=0;i<Math.min(perPage,8);i++) h += '<div class="sb-card sb-skel"><div class="sb-card__media"></div><div class="sb-card__body"><div class="sb-card__title"></div></div></div>';
      grid.innerHTML = h;
    }
    function counts(){
      chips.forEach(function(ch){
        var s = +ch.getAttribute('data-size');
        var n = state.data.filter(function(p){ return matches(p, s).length; }).length;
        var c = ch.querySelector('[data-count]');
        if(c) c.textContent = n ? n + (n === 1 ? ' pair' : ' pairs') : 'none';
        ch.classList.toggle('is-empty', !n);
      });
    }
    function sortList(){
      var mode = sortSel.value;
      var L = state.list.slice();
      if(mode === 'low') L.sort(function(a,b){ return a.min - b.min; });
      else if(mode === 'high') L.sort(function(a,b){ return b.min - a.min; });
      else if(mode === 'new') L.sort(function(a,b){ return new Date(b.p.d) - new Date(a.p.d); });
      return L;
    }
    function render(reset){
      if(reset){ grid.innerHTML = ''; state.shown = 0; }
      var L = sortList();
      var next = L.slice(state.shown, state.shown + perPage);
      grid.insertAdjacentHTML('beforeend', next.map(function(x){ return card(x.p, x.hits, fmt); }).join(''));
      state.shown += next.length;
      moreBtn.hidden = state.shown >= L.length;
      empty.hidden = L.length > 0;
      bar.hidden = L.length === 0;
      status.innerHTML = '<b>' + L.length + '</b> ' + (L.length === 1 ? 'pair' : 'pairs') + ' in stock in <b>EU ' + state.size + '</b>';
    }
    function select(size, opts){
      opts = opts || {};
      state.size = size;
      root.dispatchEvent(new CustomEvent('sb:size', {bubbles:true, detail:size}));
      chips.forEach(function(ch){ ch.setAttribute('aria-selected', String(+ch.getAttribute('data-size') === size)); });
      var active = root.querySelector('.sb-chip[aria-selected="true"]');
      var strip = root.querySelector('.sb-size__chips');
      if(active && strip && strip.scrollWidth > strip.clientWidth){ strip.scrollTo({left: active.offsetLeft - strip.clientWidth/2 + active.clientWidth/2, behavior:'smooth'}); }
      if(!state.data){ skeleton(); }
      fetchAll(scope).then(function(data){
        state.data = data;
        counts();
        state.list = data.map(function(p){
          var hits = matches(p, size);
          return hits.length ? {p:p, hits:hits, min:Math.min.apply(null, hits.map(function(v){ return v.p; }))} : null;
        }).filter(Boolean);
        render(true);
      }).catch(function(){
        grid.innerHTML = '';
        empty.hidden = false;
        empty.querySelector('p').textContent = 'Could not load products. Please refresh.';
      });
      if(!opts.silent){
        try{ var u = new URL(location.href); u.searchParams.set('size', size); history.replaceState(null, '', u); }catch(e){}
      }
    }

    chips.forEach(function(ch){ ch.addEventListener('click', function(){ select(+ch.getAttribute('data-size')); }); });
    sortSel.addEventListener('change', function(){ render(true); });
    moreBtn.addEventListener('click', function(){ render(false); });
    var clr = root.querySelector('[data-sb-size-clear]');
    if(clr) clr.addEventListener('click', function(){
      state.size = null; grid.innerHTML = ''; bar.hidden = true; moreBtn.hidden = true; empty.hidden = true;
      chips.forEach(function(ch){ ch.setAttribute('aria-selected','false'); });
      try{ var u = new URL(location.href); u.searchParams.delete('size'); history.replaceState(null, '', u); }catch(e){}
      root.dispatchEvent(new CustomEvent('sb:size-clear', {bubbles:true}));
    });

    var q = null;
    try{ q = parseInt(new URL(location.href).searchParams.get('size'), 10); }catch(e){}
    var initial = q || parseInt(root.getAttribute('data-initial'), 10);
    if(initial >= 35 && initial <= 49){ select(initial, {silent: !q}); }
    else {
      var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
        if(es[0].isIntersecting){ io.disconnect(); fetchAll(scope).then(function(d){ state.data = d; counts(); }); }
      }, {rootMargin:'300px'}) : null;
      if(io) io.observe(root); else fetchAll(scope).then(function(d){ state.data = d; counts(); });
    }
  }

  function boot(){ [].forEach.call(document.querySelectorAll('[data-sb-size]:not([data-ready])'), function(r){ r.setAttribute('data-ready',''); init(r); }); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();